import { useQuery } from '@tanstack/react-query'

import { CommonService } from '@/services/common.service'

const PLATFORMS_CACHE_TTL = 1000 * 60 * 60 * 4

export const usePlatforms = () => {
	const { data: platforms = [], isLoading: isPlatformsLoading } = useQuery({
		queryKey: ['getPlatforms'],
		queryFn: () => CommonService.getPlatforms(),
		staleTime: PLATFORMS_CACHE_TTL,
		cacheTime: PLATFORMS_CACHE_TTL
	})

	return {
		platforms,
		isPlatformsLoading
	}
}
